import React, { useEffect, useRef } from 'react'
//import HtmlToReact, { Parser as HtmlToReactParser } from 'html-to-react';
import { useSelector } from 'react-redux'
import RenderedHtmlContent from '../rendered_html_content'

// class CustomHtmlComponent extends React.Component {

//   constructor(props) {
//     super(props);
//   }


//   render() {

//     const html = this.props.html

//     const isValidNode = () => {
//       return true;
//     };

//     const processingInstructions = [
//       {
//         replaceChildren: true,
//         shouldProcessNode: function (node) {
//           return node && node.data = "<Agenda/>"
//         },
//         processNode: function (node, children) {
//           return <Agenda/>
//         }   
//       },
//       {
//         shouldProcessNode: function (node) { return true; },
//         processNode: new HtmlToReact.ProcessNodeDefinitions(React).processDefaultNode
//       }
//     ];
//     const htmlToReactParser = new HtmlToReactParser();
//     let reactComponent = htmlToReactParser.parseWithInstructions(html, isValidNode, processingInstructions);

//     return reactComponent
//   }
// }<CustomHtmlComponent html={html}/>

export default function TextPreview({data, onModalClose}) {
  let html = data?.textData?.html || ""
  const tagOwner = useSelector(state => state.tagOwner)
  const guestListEntries = useSelector(state => state.guestListEntries)
  const events = useSelector(state => state.events)

  
  const ref = useRef(null)
  useEffect(() => {
    if(window.pageYOffset > ref.current.offsetTop) {
      console.log("ref.current.scrollTop", document.body.scrollTop, document.body.scrollTop, window.pageXOffset, window.pageYOffset)
      ref.current.setAttribute("style", "top: " + String(window.pageYOffset + 10) + "px")
    }
  }, [])

  if(tagOwner && tagOwner.id) {
    html = html.replace(/@tag_owner_id@/g, tagOwner.id)
  }

  const placeholders = {tagOwner: tagOwner, guestListEntries: guestListEntries, events: events}

  return <div className="modal preview-modal text-preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                  onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
      <div className="modal-dialog" ref={ref} role="document">
          <div className="modal-content" onClick={(event) => {
            event.stopPropagation()
          }}>
              <div className="modal-header">
                  <div className="modal-title">
                      {data.title}
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                        onModalClose ? onModalClose() : alert("No modal close action available.")
                    }}>
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div className="modal-body">
                <RenderedHtmlContent html={html} placeholders={placeholders}/>
              </div>
          </div>
      </div>
  </div>;
}
